import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { BASE_URL } from './Server';

export const baseQuery = fetchBaseQuery({
    baseUrl: BASE_URL + "/",
})

export const CampaignApi = createApi({
    baseQuery: baseQuery,
    reducerPath: "AddCampaignReducer",
    tagTypes: ["AddCampaign"],
    endpoints: (build) => ({
        getAllCampaigns: build.query<any, any>({
            query: (body) => ({ url: `${process.env.REACT_APP_CMS_URL || 'https://dev.nightlife.net'}/testunl/node/${body.id}.json?img_preset=service_socialad&img_preset2=service_socialad&img_preset3=service_socialad&admedia=${body.mediaType}` }),

            providesTags: (body) => [{ type: 'AddCampaign', body }],

        }),
    })
})

export const {
    useGetAllCampaignsQuery } = CampaignApi
